import React from 'react'


const Education = () => {
  return (
    <section id='education' className='hero2  bg-slate-400 '>
       
    <div className='container lg:pt-5'>
        
        <div className='text-center'>
            <h2 className=' text-white font-[800] text-[2.4rem] mb-5'>
                Education
                </h2> 
                

        </div>
        <div className='flex flex-col justify-center sm:py-12'> 
        <div className='w-full py-3 px-2 sm:max-w-xl sm:mx-auto sm:px-0'>
            <div className='relative text-grey-700 antialised text-sm text-semibold '>
                <div className='hidden absolute w-1 sm:block bg-indigo-300 h-full
                left-1/2 transform-translate-x-1/2'></div> 
                    <div className='mt-6 sm:mt-0 sm:mb-12 '>
                        <div className='flex items-center flex-col sm:flex-row'>
                            <div className='flex justify-start w-full mx-auto items-center'>
                                <div className='w-full sm:w-1/2 sm:pr-8'>
                                    <div 
                                    data-aos='fade-right' 
                                    data-aos-delay='100'
                                    data-aos-duration='1400'
                                    
                                    
                                    
                                    className=' text bg-white p-4 rounded
                                    shadow group hover:bg-primaryColor cursor-pointer ease-in duration-150'>
                                        <h3 className='text-primaryColor font-[700] mb-3 group-hover:text-white 
                                        group-hover:font-[600] text-2xl'>CDAC</h3>
                                        <p>Post Graduate Diploma In Advanced Computing (Noida) 2023 </p>
                                        

                                    </div>

                                </div>

                            </div>
                            <div className='rounded-full bg-black border-white border-4 w-10 h-10
                            absolute right-1/2 transform translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center
                            justify-center'>
                                

                            </div>

                        </div>

                    </div>
                    {/* right card*/}
                    <div className='mt-6 sm:mt-0 sm:mb-12 '>
                        <div className='flex items-center flex-col sm:flex-row'>
                            <div className='flex justify-end w-full mx-auto items-center'>
                                <div className='w-full sm:w-1/2 sm:pl-8'>
                                    <div
                                      data-aos='fade-left' 
                                      data-aos-delay='100'
                                      data-aos-duration='1400'
                                       className=' text bg-white p-4 rounded
                                    shadow group hover:bg-primaryColor cursor-pointer ease-in duration-150'>
                                        <h3 className='text-primaryColor font-[700] mb-3 group-hover:text-white 
                                        group-hover:font-[600] text-2xl'>B.E </h3>
                                        <p>Mechanical Engineering (Savitribai Phule PUne University) 2019 </p>

                                    </div>

                                </div>

                            </div>
                            <div className='rounded-full bg-black border-white border-4 w-10 h-10
                            absolute right-1/2 transform translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center
                            justify-center'>
                                 

                            </div>

                        </div>

                    </div>
                    <div className='mt-6 sm:mt-0 sm:mb-12 '>
                        <div className='flex items-center flex-col sm:flex-row'>
                            <div className='flex justify-start w-full mx-auto items-center'>
                                <div className='w-full sm:w-1/2 sm:pr-8'>
                                    <div
                                      data-aos='fade-right' 
                                      data-aos-delay='100'
                                      data-aos-duration='1400'
                                       className=' text bg-white p-4 rounded
                                    shadow group hover:bg-primaryColor cursor-pointer ease-in duration-150'>
                                        <h3 className='text-primaryColor font-[700] mb-3 group-hover:text-white 
                                        group-hover:font-[600] text-2xl'>Diploma</h3>
                                        <p>Diploma In Mechanical Engineering (MSBTE) 2016</p>

                                    </div>

                                </div>

                            </div>
                            <div className='rounded-full bg-black border-white border-4 w-10 h-10
                            absolute right-1/2 transform translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center
                            justify-center'>
                                 

                            </div>

                        </div>

                    </div>
                    <div className='mt-6 sm:mt-0 sm:mb-12 '>
                        <div className='flex items-center flex-col sm:flex-row'>
                            <div className='flex justify-end w-full mx-auto items-center'>
                                <div className='w-full sm:w-1/2 sm:pl-8'>
                                    <div 
                                      data-aos='fade-left' 
                                      data-aos-delay='100'
                                      data-aos-duration='1400' 
                                      className=' text bg-white p-4 rounded
                                    shadow group hover:bg-primaryColor cursor-pointer ease-in duration-150'>
                                        <h3 className='text-primaryColor font-[700] mb-3 group-hover:text-white 
                                        group-hover:font-[600] text-2xl'>SSC</h3>
                                        <p>Maharashtra State Board Of Secondary And Higher Secondary Education (2013)</p>

                                    </div>

                                </div>

                            </div>
                            <div className='rounded-full bg-black border-white border-4 w-10 h-10
                            absolute right-1/2 transform translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center
                            justify-center'>
                                

                            </div>

                        </div>

                    </div>
                   

            </div>


        </div>

        </div>

    </div>
    
    
    </section>
  )
}

export default Education